import { getParameterContentType } from './lib/get-parameter-content-type.js';
import matchesMimeType from './lib/matches-mimetype.js';
import { dereferenceRef } from './lib/refs.js';
import { types as jsonSchemaTypes } from './operation/transformers/get-parameters-as-json-schema.js';

export const supportedMethods = ['get', 'put', 'post', 'delete', 'options', 'head', 'patch', 'trace'] as const;

export const SERVER_VARIABLE_REGEX: RegExp = /{([-_a-zA-Z0-9:.[\]]+)}/g;

export { getParameterContentType, jsonSchemaTypes, matchesMimeType, dereferenceRef };
